import type { DocumentMentionInfo } from '@atlas/lexical-core';
import { buildMentionMarkdownString } from '@atlas/lexical-core/utils/mentions';
import { INSERT_DOCUMENT_MENTION_COMMAND } from '@core/component/LexicalMarkdown/plugins/mentions';
import type { LexicalEditor } from 'lexical';

export type ChatAttachmentMention = Pick<
  DocumentMentionInfo,
  'documentId' | 'documentName' | 'blockName' | 'channelType' | 'blockParams'
>;

export function chatAttachmentMentionToMarkdown(
  mention: ChatAttachmentMention
): string {
  return buildMentionMarkdownString({
    type: 'document',
    ...mention,
    blockParams: mention.blockParams ?? {},
  });
}

export function insertChatAttachmentMention(
  editor: LexicalEditor,
  mention: ChatAttachmentMention
): boolean {
  return editor.dispatchCommand(INSERT_DOCUMENT_MENTION_COMMAND, mention);
}
